module.exports = __webpack_public_path__ + "img/standing_up_man.6f21e252.svg";